var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftarrowPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.7742 0.42172C9.21997 -0.140573 8.32142 -0.140573 7.76705 0.42172L0.830409 7.46564C-0.277186 8.59043 -0.276746 10.4129 0.831388 11.537L7.77216 18.5783C8.32653 19.1406 9.22508 19.1406 9.77945 18.5783C10.3337 18.0161 10.3337 17.1044 9.77945 16.5421L3.83875 10.5155C3.28449 9.95321 3.28449 9.04166 3.83875 8.47927L9.7742 2.45793C10.3286 1.89565 10.3286 0.983998 9.7742 0.42172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrowPagination);
export default __webpack_public_path__ + "static/media/leftarrowPagination.969afba399bcf019ff496b198203e130.svg";
export { ForwardRef as ReactComponent };